<template>
  <VueFinalModal
    v-model="isOpen"
    content-transition="vfm-fade"
    :click-to-close="true"
    class="flex justify-center items-center p-6"
    content-class="relative w-full max-w-md bg-white rounded-2xl shadow-xl z-50 ring-1 ring-black/5 overflow-hidden"
    @close="close"
  >
    <div class="p-6">
      <div class="flex gap-4">
        <div
          class="w-12 h-12 rounded-full shrink-0 flex items-center justify-center"
          :class="iconWrapperClass"
        >
          <svg v-if="variant === 'danger'" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-white">
            <path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/>
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="text-[#1c4848]">
            <circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/>
          </svg>
        </div>
        <div class="flex-1 min-w-0">
          <h3 class="text-lg font-semibold text-[#1c4848] tracking-tight">
            {{ title }}
          </h3>
          <p class="mt-2 text-sm text-[#1c4848]/70 leading-relaxed">
            {{ message }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-end gap-3 px-6 pb-6 pt-0">
      <button
        type="button"
        class="px-4 py-2.5 rounded-xl text-sm font-semibold text-[#1c4848]/70 hover:text-[#1c4848] hover:bg-[#1c4848]/5 transition-colors"
        @click="close"
      >
        {{ cancelLabel }}
      </button>
      <button
        type="button"
        :class="confirmButtonClass"
        class="px-5 py-2.5 rounded-xl text-sm font-semibold transition-colors"
        @click="confirm"
      >
        {{ confirmLabel }}
      </button>
    </div>
  </VueFinalModal>
</template>

<script setup>
import { computed } from 'vue';
import { VueFinalModal } from 'vue-final-modal';

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  title: { type: String, default: 'Confirm' },
  message: { type: String, default: '' },
  confirmLabel: { type: String, default: 'Confirm' },
  cancelLabel: { type: String, default: 'Cancel' },
  variant: { type: String, default: 'default' },
});

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel']);

const isOpen = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
});

const iconWrapperClass = computed(() =>
  props.variant === 'danger' ? 'bg-red-500' : 'bg-[#1c4848]/10'
);

const confirmButtonClass = computed(() =>
  props.variant === 'danger'
    ? 'bg-red-500 text-white hover:bg-red-600'
    : 'bg-[#1c4848] text-white hover:bg-[#153838]'
);

function close() {
  emit('update:modelValue', false);
  emit('cancel');
}

function confirm() {
  emit('confirm');
  emit('update:modelValue', false);
}
</script>
